var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 8.7487L10.7354 2.35042C10.5295 2.17709 10.269 2.08203 9.99996 2.08203C9.73088 2.08203 9.47038 2.17709 9.26454 2.35042L1.66663 8.7487",
    stroke: "#464255",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 7.91797V13.3346C17.0833 15.2893 17.0833 16.2666 16.5667 16.9399C16.4337 17.1132 16.2785 17.2684 16.1052 17.4014C15.432 17.918 14.4546 17.918 12.5 17.918V14.168C12.5 12.9895 12.5 12.4002 12.1339 12.0341C11.7677 11.668 11.1785 11.668 9.99996 11.668C8.82146 11.668 8.23219 11.668 7.86608 12.0341C7.49996 12.4002 7.49996 12.9895 7.49996 14.168V17.918C5.54531 17.918 4.56799 17.918 3.89473 17.4014C3.72139 17.2684 3.56624 17.1132 3.43324 16.9399C2.91663 16.2666 2.91663 15.2893 2.91663 13.3346V7.91797",
    stroke: "#464255",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewBlack);
export default __webpack_public_path__ + "static/media/overview-black.058fe3d8788ed8c01ee16e1dba5ff610.svg";
export { ForwardRef as ReactComponent };